export default __webpack_public_path__ + "static/media/pestate.89a6bdae.png";